import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuthUserTy } from "../../../config/types";

const initialState: Omit<AuthUserTy,'token_type'> = {
  isSuccess: false,
};

export const authState = createSlice({
  name: "authUser",
  initialState,

  reducers: {
    loginResponse: (_state, action: PayloadAction<AuthUserTy>) => {
      return action.payload
    },

  },
});

export const { loginResponse } = authState.actions;

export default authState.reducer;
